import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SendPush } from "../../redux/api/pushnotification.api";
import {
  DeleteQuizTitlesCall,
  GetQuizTitlesCall,
} from "../../redux/api/quizTitle.api";
import { setLang } from "../../redux/slices/generalSlice";

const PushNotifications = () => {
  const [items, setItems] = useState([]);
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [body, setBody] = useState("");
  const [link, setLink] = useState("");
  const [message, setMessage] = useState("");
  const lang = useSelector((state) => state.general?.lang);
  const [type] = useState("histology");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchTitles = async () => {
    const res = await GetQuizTitlesCall({ lang, type });
    if (res?.status === 200) {
      setItems(res.data);
    }
  };

  const handleLanguageChange = (event) => {
    // setLanguage(event.target.value);
    dispatch(setLang(event.target.value));
    fetchTitles();
  };

  const handlePushNotifications = (id) => {
    const confirmation = window.confirm(
      "Are you sure you want send this push? "
    );
    console.log("pippo confirmation", confirmation);

    if (confirmation) {
      const body = {
        type: "news",
        title,
        subTitle,
        body,
        lang: "en",
        link,
      };
      console.log("pippo body", body);

      SendPush(body);
    }
    alert("Push sent successfully");
  };

  useEffect(() => {
    fetchTitles();
  }, []);

  const handleDeleteTitle = async (id) => {
    if (window.confirm("Are you sure you want to delete this title?")) {
      const res = await DeleteQuizTitlesCall({ title_id: id });
      if (res?.status === 200) {
        setMessage("Deleted successfully!");
        fetchTitles();
      }
    }
  };

  const handleTitle = (t) => {
    console.log("pippo t", t);
    setTitle(t.target?.value);
  };
  const handleSubTitle = (t) => {
    setSubTitle(t.target?.value);
  };
  const handleLink = (t) => {
    setLink(t.target?.value);
  };
  const handleBody = (t) => {
    setBody(t.target?.value);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1} display="flex" justifyContent="flex-end" mb={2}>
        <Grid container spacing={2} alignItems="center">
          {/* Add Title Button on the Left */}
          <Grid item>
            <MDButton
              color="info"
              disabled={title && subTitle && (body || link) ? false : true}
              variant="contained"
              onClick={() => handlePushNotifications()}
            >
              Send Push
            </MDButton>
          </Grid>

          {/* Language Dropdown on the Right */}
          <Grid
            item
            xs
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <FormControl style={{ width: 250 }}>
              <InputLabel>Language</InputLabel>
              <Select
                value={lang}
                onChange={handleLanguageChange}
                style={{ height: 50 }}
              >
                <MenuItem value="en">English</MenuItem>
                <MenuItem value="pt">Portugal</MenuItem>
                <MenuItem value="es">Spanish</MenuItem>
                <MenuItem value="it">Italian</MenuItem>
                <MenuItem value="ge">Germany</MenuItem>
                <MenuItem value="nl">Dutch</MenuItem>
                <MenuItem value="cn">Chines</MenuItem>
                <MenuItem value="ja">Japanese</MenuItem>
                <MenuItem value="ar">Arabic</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox py={1}>
        <label
          style={{
            display: "block",
            fontSize: 14,
            marginTop: 10,
            marginBottom: 5,
            fontWeight: "bold",
          }}
        >
          Title
        </label>
        <input
          type="text"
          defaultValue={title}
          onChange={handleTitle}
          style={{
            marginTop: 10,
            width: "100%",
            height: 35,
            padding: 8,
            borderRadius: 8,
          }}
        />
        <label
          style={{
            display: "block",
            fontSize: 14,
            marginTop: 20,
            marginBottom: 5,
            fontWeight: "bold",
          }}
        >
          Sub Title
        </label>
        <input
          type="text"
          defaultValue={subTitle}
          onChange={handleSubTitle}
          multiple={10}
          style={{
            height: 35,
            padding: 8,
            width: "100%",
            borderRadius: 8,
          }}
        />
        <label
          style={{
            display: "block",
            fontSize: 14,
            marginTop: 10,
            marginBottom: 5,
            fontWeight: "bold",
          }}
        >
          Link
        </label>
        <input
          type="text"
          defaultValue={link}
          onChange={handleLink}
          style={{
            marginTop: 10,
            width: "100%",
            height: 35,
            padding: 8,
            borderRadius: 8,
          }}
        />
        <label
          style={{
            display: "block",
            fontSize: 14,
            marginTop: 20,
            marginBottom: 5,
            fontWeight: "bold",
          }}
        >
          Body
        </label>
        <input
          type="text"
          defaultValue={body}
          onChange={handleBody}
          multiple={10}
          style={{
            height: 135,
            padding: 8,
            width: "100%",
            borderRadius: 8,
          }}
        />
      </MDBox>
      <MDBox py={10}>
        <Grid container spacing={3}>
          {items.map((t, index) => (
            <MDBox
              key={index}
              p={2}
              display="flex"
              flexDirection="column"
              alignItems="center"
              borderRadius="8px"
              style={{
                marginBottom: 15,
                backgroundColor: "white",
                marginRight: 16,
              }}
            >
              <img
                src={t?.image}
                style={{
                  width: 100,
                  height: "auto",
                  borderRadius: "8px",
                  marginBottom: "10px",
                }}
              />
              <li
                style={{ display: "flex", flexDirection: "column" }}
                key={t.id}
              >
                <label
                  style={{
                    display: "block",
                    fontSize: 14,
                    marginTop: 10,
                    marginBottom: 5,
                    fontWeight: "bold",
                  }}
                >
                  Title
                </label>

                <input
                  type="text"
                  defaultValue={t.image}
                  style={{
                    height: 35,
                    padding: 8,
                    borderRadius: 8,
                    width: "100%",
                  }}
                />
              </li>
              <div style={{ gap: 10, display: "flex", flexDirection: "row" }}>
                <button
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    borderWidth: 0,
                    borderRadius: 6,
                    marginTop: 20,
                    padding: 8,
                  }}
                  onClick={() => handleDeleteTitle(t.id)}
                >
                  Delete
                </button>
              </div>
            </MDBox>
          ))}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default PushNotifications;
